export class BoschDataList {
  modelGas = [
    'Condens 5000W ZBR 100-3',
    'Condens 5000W ZBR 70-3',
    'Condens 5000W ZSB 14-6C',
    'Condens 9000i WM 30/150',
    'Condens 9000i WM 30/150 B',
    'CSW14/75-3A23S8800',
    'CSW24/75-3A23S8800',
    'CSW30-3A23S8800',
    'GC5300i WM 24/120 23 S0800',
    'GC7000F 100 R 23 "DK"',
    'GC7000F 75 R 23 "DK"',
    'GC9000iW 20 E 23',
    'GC9000iW 20 EB 23',
    'GC9000iW 30 E 23',
    'GC9000iW 40 23',
    'GC9000iW 50 23',
    'Logamax Plus GB162-100',
    'Logamax PLUS GB162-65 DK',
    'Logamax Plus GB162-80',
    'UC8000F 115 "DK"',
    'UC8000F 50 "DK"',
    'UC8000F 70 "DK"',
    'UC8000F 90 "DK"',
    'WBC 14-1 DE 23 S0800 DK',
    'ZBR42-3A23S8823',
    'ZBR65-1A23S0800',
    'ZBR90-1A23S0800',
    'ZBS14/150-3MA23 Rohrwdl S0800',
    'ZBS14/210-3SOE23S0800',
    'ZBS14/210S-3MA23SolarS0800',
    'ZBS22/150-3MA23 Rohrwdl S0800',
    'ZSB 14-5C 23 S0800',
    'ZSB 24-5C 23 S0800',
    'ZSB14-3C23S0800 (FFD)',
    'ZSB14-3E23S0800 (FFD)',
    'ZSB14-4C23S0800',
    'ZSB22-3 E23S0800 (FFD)',
    'ZSB22-3C23S0800 (FFD)',
    'ZSB24-4C23S0800',
    'ZSBE16-3A23S8823',
    'ZSBE28-3A23S8823',
    'ZSBR16-3A23S8823',
    'ZSBR28-3A23S8823',
    'ZSN11-7AE23 (FFD)',
    'ZWB 28-5C 23 S0800',
    'ZWB28-3C23S0800 (FFD)',
    'ZWB28-3E23S0800 (Status50)',
    'ZWB30-4C23S0800',
    'ZWB35-3 A23S8823',
    'ZWBE35-3 A23S8823',
    'ZWSB 22/28-3 A S0800',
    'ZWSB 30-4 A23 S0800'
  ];

  modelGeothermal = [
    'Bosch Compress 5000 LW 22',
    'Bosch Compress 5000 LW 30',
    'Bosch Compress 6000 10 LW dk',
    'Bosch Compress 6000 10 LWMRFdk',
    'Bosch Compress 6000 13 LW dk',
    'Bosch Compress 6000 17 LW dk',
    'Bosch Compress 6000 4,5LWMRFdk',
    'Bosch Compress 6000 6 LW dk',
    'Bosch Compress 6000 6 LWM RFdk',
    'Bosch Compress 6000 8 LW dk',
    'Bosch Compress 6000 8 LWM RFdk',
    'Bosch Compress 7000 12 LWM DK',
    'Bosch Compress 7000 12 LWM S/W DK',
    'Bosch Compress 7000 LW EHP 22-2 LW',
    'Bosch Compress 7000 LW EHP 28-2 LW',
    'Bosch Compress 7000 LW EHP 38-2 LW',
    'Bosch Compress 7000 LW EHP 48-2 LW',
    'Bosch Compress 7000 LW EHP 54-2 LW',
    'Bosch Compress 7000 LW EHP 64-2 LW',
    'Buderus Logatherm WPS22',
    'Buderus Logatherm WPS33',
    'Buderus Logatherm WPS33DK',
    'Buderus Logatherm WPS43',
    'Buderus Logatherm WPS52',
    'Buderus Logatherm WPS60',
    'CS 7001i LW 12',
    'CS 7001i LWF 12',
    'CS 7001i LWF 16',
    'CS 7001i LWF 8',
    'CS 7001i LWM 12',
    'CS 7001i LWM 16',
    'CS 7001i LWM 8',
    'CS 7001i LWMF 12',
    'CS 7001i LWMF 16',
    'CS 7001i LWMF 8',
    'CS 7001i LWMS 12',
    'CS 7001i LWMSF 12',
    'CS 7001i LWMSF 16',
    'CS 7001i LWMSF 8',
    'CS7000iLW 12 M',
    'CS7000iLW 12 MB',
    'CS7000iLW 12 MS',
    'EHP11LW',
    'EHP11LW/M',
    'EHP14LW',
    'EHP17LW',
    'EHP6LW',
    'EHP6LW/M',
    'EHP7LW',
    'EHP7LW/M',
    'EHP9LW',
    'EHP9LW/M',
    'CS 7800iLW 6',
    'CS 7800iLW 8',
    'CS 7800iLW 12',
    'CS 7800iLW 16',
    'CS 7800iLWM 6',
    'CS 7800iLWM 8',
    'CS 7800iLWM 12',
    'CS 7800iLWM 16'
  ];

  modelAirWater = [
    'Bosch Compress CS7400iAW 5',
    'Bosch Compress CS7400iAW 7',
    'Bosch Compress 6000 AW-13',
    'Bosch Compress 6000 AW-17',
    'Bosch Compress 6000 AW-5',
    'Bosch Compress 6000 AW-7',
    'Bosch Compress 6000 AW-9',
    'Bosch Compress CS7000iAW 13 OR-T',
    'Bosch Compress CS7000iAW 17 OR-T',
    'Bosch Compress CS7000iAW 5 OR-S',
    'Bosch Compress CS7000iAW 7 OR-S',
    'Bosch Compress CS7000iAW 9 OR-S',
    'BOSCH HYBRID APPLIANCE (DK)',
    'Bosch Thermotechnik Gmbh Hybrid ODU',
    'Compress 11 AWO',
    'Compress 13 AWO',
    'Compress 3000 ODU Split 11t',
    'Compress 3000 ODU Split 15t',
    'Compress 3000 ODU Split 2',
    'Compress 3000 ODU Split 4',
    'Compress 3000 ODU Split 6',
    'Compress 3000 ODU Split 8',
    'Compress 9 AWO',
    'CS5000AW 22 O'
  ];

  modelAirAir = [
    'Bosch Compress 8000 AA EHP8.5',
    'Bosch EHP 5.0 AA. Da',
    'Bosch EHP 5.0 AA/I',
    'Bosch EHP 5.0 AA/O',
    'Bosch EHP 6.0-1 AA. Da',
    'Bosch EHP 6.0-1 AA/I',
    'Bosch EHP 6.0-1 AA/O',
    'Bosch EHP 6.5 AA/I',
    'Bosch EHP 6.5 AA/O',
    'CL3000i-Set 35 WE',
    'CL3000i-Set 53 WE',
    'Climate 3000i - CL3000i 35 E',
    'Climate 3000i - CL3000i 53 E',
    'Climate 3000i - CL3000i 70 E',
    'Climate 3000i - CL3000iU W 35 E',
    'Climate 3000i - CL3000iU W 53 E',
    'Climate 3000i - CL3000iU W 70 E',
    'Climate 6100i - CL6100i 65 HE',
    'Climate 6100i - CL6100i-Set 50 HE',
    'Climate 6100i - CL6100i-Set 65 HE',
    'Climate 6100i - CL6100i-W 65 HE',
    'Climate 8100i - CL8100i-Set 65 HE',
    'Climate 9100i - CL9100i-Set 85 HE',
    'Compress 7000 EHP 6.5 AA Da',
    'EHP 8.5 OD',
    'IVT L/L 12 PHR-N AA/I Silverline',
    'IVT L/L 12 PHR-N AA/O',
    'IVT L/L NI 09 PRN AA/O',
    'IVT L/L NI 12 LRN Out Door Unit',
    'IVT L/L NI 12 PRN AA/O',
    'IVT L/L NI12 KR-N Out Door Unit'
  ];

  modelInside = {
    'Compress 3000 ODU Split 2-4-6': [
      'Compress 3000 AWBS 2-6',
      'Compress 3000 AWES 2-6',
      'Compress 3000 AWMS 2-6',
      'Compress 3000 AWMSS 2-6'
    ],
    'Compress 3000 ODU Split 8-11-15': [
      'Compress 3000 AWBS 8-15',
      'Compress 3000 AWES 8-15',
      'Compress 3000 AWMS 8-15',
      'Compress 3000 AWMSS 8-15'
    ],
    'Bosch Compress 6000 AW-5-7-9': [
      'Compress 6000 Bosch AWM 5-9'
    ],
    'Bosch Compress 6000 AW-13-17': [
      'Compress 6000 AWM 13-17'
    ],
    'Compress 7000 9': [
      'Compress 7000 AWB 9',
      'Compress 7000 AWE 9',
      'Compress 7000 AWM 9',
      'Compress 7000 AWMS 9'
    ],
    'Compress 7000 17': [
      'Compress 7000 AWB 17',
      'Compress 7000 AWE 17',
      'Compress 7000 AWM 17',
      'Compress 7000 AWMS 17'
    ],
    'CC160': [
      'CC160'
    ],
    'CMO': [
      'CMO 200',
      'CMO 300'
    ]
  }
}
